export default __webpack_public_path__ + "static/media/hotJobsRed.fa315652.svg";